<template>
  <!--  <google-analytics-inertia/>-->
  <google-analytics-inertia />

  <div class="flex min-h-screen flex-col">

    <frontend-header v-if="!hideHeader" />

    <slot name="page_header" />

    <main class="flex-grow">
      <slot name="content" />
    </main>

    <frontend-footer v-if="!hideFooter" />

  </div>
</template>

<script>

import GoogleAnalyticsInertia from '@/Components/GoogleAnalyticsInertia.vue'
import FrontendHeader from '@/Components/FrontendHeader.vue'
import FrontendFooter from '@/Components/FrontendFooter.vue'

export default {
  name: 'FrontendLayout',
  components: { FrontendFooter, FrontendHeader, GoogleAnalyticsInertia },
  props: {
    hideHeader: {
      type: Boolean,
      default: false,
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    console.log('props', this.$page)
  },
}
</script>

<style scoped></style>
